import React, { useContext, useState } from "react";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AgregarDevolucionProveedor from "../DevolucionesProveedorCRUD/AgregarDevolucionProveedor";
import { ConfirmDialog } from "primereact/confirmdialog";
import Loader from "../../../../../../Base/Components/Loader/Loader";

const DevolucionesProveedorListado = ({
  listadoDev,
  getInfo,
  selectedDetalle, 
  setSelectedDetalle,
  setOrderToShow,
  setOrdenDialog,
  toast,
  loading
}) => {

  const { userAuth } = useContext(AuthContext);
  const [showDialogD, setShowDialogD] = useState(false);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(29)
  );

  const OrdenC = (Id) => {
    setOrderToShow(Id);
    showModal();
  };

  const showModal = () => {
    setOrdenDialog(true);
  };


  const columns = [
    {
      // Comment
      field: "IdDevolucion",
      header: "ID",
      headerEn: "ID",
      body: (rowData) => rowData.IdDevolucionDetalle,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogD(true);
        if (selectedDetalle.length > 1) {
          setSelectedDetalle(selectedDetalle);
        } else {
          setSelectedDetalle([data]);
        }
      },
    },
    {
      // Comment
      field: "FechaDevolucion",
      header: "Fecha Devolución",
      headerEn: "Date Returns",
      body: (rowData) => rowData.FechaDevolucion,
      frozen: "frozen",
      className: "large",
      Format: "DateTime",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      // cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      // Comment
      field: "NumeroIngreso",
      header: "No. Ingreso",
      frozen: true,
      headerEn: "No. Income",
      className: "small",
      Format: "Modal",
      // align: "center",
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.NumeroIngreso);
      },
    },
    {
      // Comment
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Product",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      // Comment
      field: "DescripcionProducto",
      header: "Descripción",
      headerEn: "Description",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      // Comment
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "Xsmall",
    },
    {
      // Comment
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "Xsmall",
    },
    {
      // Comment
      field: "NombreTipoProducto",
      header: "SubCategoría",
      headerEn: "SubCategory",
      className: "small",
    },
    {
      // Comment
      field: "UserName",
      header: "User Create",
      headerEn: "Username",
      className: "small",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "Ingreso",
      header: "Ingresó",
      headerEn: "Income",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      // Comment
      field: "Inventario",
      header: "Inventario",
      headerEn: "Amount Entered",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      // Comment
      field: "Devolucion",
      header: "Devuelto",
      headerEn: "Refund",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      frozen: "frozen",
      alignFrozen: "right",
    },
    // LEMPIRAS
    {
      headerName: "Lempiras",
      children: [
        {
          header: "Precio L",
          headerEn: "Price L",
          field: "PrecioL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "SubTotal L",
          headerEn: "SubTotal L",
          field: "SubTotalL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV L",
          headerEn: "TAX L",
          field: "ISVL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Desc. L",
          headerEn: "Disc. L",
          field: "DescuentoL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto L",
          headerEn: "Amount L",
          field: "MontoL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
    // DOLARES
    {
      headerName: "Dolares",
      children: [
        {
          header: "Precio D",
          headerEn: "Price D",
          field: "PrecioD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "SubTotal D",
          headerEn: "SubTotal D",
          field: "SubTotalD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV D",
          headerEn: "TAX D",
          field: "ISVD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "DesC. D",
          headerEn: "Disc. D",
          field: "DescuentoD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto D",
          headerEn: "Amount D",
          field: "MontoD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoDev,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
    showModal: (e) => showModal(e),
  };


  return (
    <div style={{ height: "88vh" }}>
      <Loader loading={loading}></Loader>
      <AgGrid table={table} />

      {showDialogD && (
        <AgregarDevolucionProveedor
          selected={selectedDetalle}
          setSelected={setSelectedDetalle}
          showDialogDI={showDialogD}
          setShowDialogDI={setShowDialogD}
          getInfo={getInfo}
          actualizarScreen={getInfo}
        />
      )}
    </div>
  );
};

export default DevolucionesProveedorListado;
